import { NotFound } from "@/components/NotFound";

export function NotFoundPage() {
    return <NotFound />;
}
